import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/shadcn/sheet'
import { ScrollArea } from '@/components/shadcn/scroll-area'
import { FormContentV2 } from '../../../FormComponent'
import { InferFormValues, JsonFormSchemaV2 } from '../../../FormComponent/types'
import {
  buildNewRootIndexNode,
  CREATE_INDEX_NODE_FORM_SCHEMA,
} from './createIndexNodeFormSchema'
import { ReorderableIndexNode } from './indexReorderUtils'

export function IndexCreateSheet({
  isOpen,
  onOpenChange,
  onAdd,
}: {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  onAdd: (node: ReorderableIndexNode) => void
}) {
  const handleSubmit = (data: InferFormValues<JsonFormSchemaV2>) => {
    const chapter = buildNewRootIndexNode(data)
    onAdd({
      id: chapter.id,
      title: chapter.title,
      description: chapter.description,
      children: [],
    })
    onOpenChange(false)
  }

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full sm:max-w-lg">
        <SheetHeader className="border-b pb-5">
          <SheetTitle>Add Index Item</SheetTitle>
          <SheetDescription>
            Add a new root item to the index. Drag it into position, then save your changes.
          </SheetDescription>
        </SheetHeader>
        <ScrollArea className="h-[calc(100%-77px)]">
          <div className="pr-6 pt-4">
            <FormContentV2
              schema={CREATE_INDEX_NODE_FORM_SCHEMA}
              submitHandler={handleSubmit}
              resetOnOpen={isOpen}
            />
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  )
}
